import React, { useState, useEffect } from "react";
import OrderForm from "../Forms/OrderForm";
import useCartStore from "../../stores/useCartStore";
import CartItem from "./cartItem";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { GetTeacherInformation } from "../../actions/teacherQueries";

export default function ConfirmedOrder() {
  const navigate = useNavigate();
  const location = useLocation();
  const [totalPrice, setTotalPrice] = useState(0);

  const result = useCartStore((state) => state.result);
  const clearCart = useCartStore((state) => state.clearCart);
  const orderContext = location.state?.orderContext ?? null;
  const teacherInfo = GetTeacherInformation({ enabled: !orderContext });

  useEffect(() => {
    setTotalPrice(0);
    result.forEach((order) => {
      setTotalPrice(
        (prevstate) =>
          prevstate + order.priceStudent * order.addedStudents.length
      );
    });
  }, [result]);

  const cleanCartAfterPurchase = () => {
    clearCart();
  };

  const cartList = () => {
    return result.map((cartItem, i) => {
      if (cartItem.addedStudents.length > 0) {
        return (
          <CartItem
            key={i}
            readonly={true}
            cartItem={cartItem}
            onAddUnit={null}
            onDeductUnit={null}
            handleDeleteFromCart={null}
          />
        );
      } else {
        return null;
      }
    });
  };

  // Kontexten bärs i routerns state och överlever inte ett bokmärke eller en ny flik.
  // Utan den skulle adminvägen falla tillbaka på lärarfrågan, som svarar 403 för en
  // admin, och OrderForm krascha på teacherInformation.customer.
  if (!orderContext && location.pathname.startsWith("/superuser")) {
    return <Navigate to="/superuser/schools/classes" replace />;
  }

  if (!orderContext && teacherInfo.isPending) return null;

  const orderInfo = orderContext ?? teacherInfo.data;

  return (
    <>
      <OrderForm
        navigate={navigate}
        cartList={cartList}
        cart={{ result }}
        totalPrice={totalPrice}
        teacherInformation={orderInfo}
        contact={orderContext?.contact}
        returnTo={orderContext?.returnTo}
        cleanCartAfterPurchase={() => cleanCartAfterPurchase()}
      />
    </>
  );
}
